import { clientEnvironment } from 'shared/platform/environment';

export const BUILD_ID = clientEnvironment.buildId;
export const BUILD_TIME = clientEnvironment.buildTime;
export const BUILD_GIT_SHA = clientEnvironment.buildGitSha;
export const IS_PRODUCTION_BUILD = clientEnvironment.isProduction;
